<template>
  <div class="statistics-table-container">
    <el-table
      ref="table"
      :data="tableList"
      border
      :height="height"
      @row-click="handleRowClick"
    >
      <el-table-column
        v-for="item in tableShowList"
        :key="item.field_name_en"
        :prop="item.field_name_en"
        :label="item.field_name"
        :width="item.width"
      >
        <template slot="header" slot-scope="scope">
          <div class="table-sort-header">
            <p v-if="!item.sort" class="tit">{{ item.field_name }}</p>
            <el-dropdown
              trigger="click"
              placement="bottom"
              @command="handleTableSort($event, item)"
              v-if="item.field_name === '执行人' && item.field_type === 'fixed' && item.sort"
            >
              <p class="tit sort-name">
                {{ item.field_name }}
                <i
                  class="icon iconfont"
                  :class="item.sort === 'name' ? 'iconicon_a_z' : 'iconicon_sort_settings'"
                ></i>
              </p>
              <el-dropdown-menu slot="dropdown" class="statistics-table-sort-dropdown">
                <el-dropdown-item
                  v-for="data in count"
                  :key="data.value"
                  :command="data.value"
                >
                  {{ data.label }}
                  <i v-if="item.sort === data.value" class="icon iconfont iconicon_selected_more_task"></i>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown
              trigger="click"
              placement="bottom"
              @command="handleTableSort($event, item)"
              v-else-if="item.field_type === 'fixed' && item.sort"
            >
              <p class="tit sort-name">
                {{ item.field_name }}
                <i
                  class="icon iconfont"
                  :class="item.sort === 'desc' ? 'iconicon_reverse_order' : 'iconicon_ascending_order'"
                ></i>
              </p>
              <el-dropdown-menu slot="dropdown" class="statistics-table-sort-dropdown">
                <el-dropdown-item
                  v-for="data in sort"
                  :key="data.value"
                  :command="data.value"
                >
                  {{ data.label }}
                  <i v-if="item.sort === data.value" class="icon iconfont iconicon_selected_more_task"></i>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>

        <template slot-scope="scope">
          <div class="table-item" :style="getTableStyleItem(scope.row, item.field_name_en)">

            <!-- 任务名称 -->
            <span class="table-item-task-name" v-if="item.field_name_en === 'task_name'">
              <toolTip style="wdith:100%;" :title="scope.row[item.field_name_en]">
                <span>{{ scope.row[item.field_name_en] }}</span>
              </toolTip>
              <!-- {{ scope.row[item.field_name_en] }} -->
            </span>

            <!-- 所属清单 -->
            <span class="table-item-task-list" v-if="item.field_name_en === 'task_list'">
              <toolTip style="wdith:100%;" :title="scope.row[item.field_name_en].title">
                <span>{{ scope.row[item.field_name_en].title }}</span>
              </toolTip>
              <!-- {{ scope.row[item.field_name_en].title }} -->
            </span>

            <!-- 返回时间格式的 -->
            <span class="table-item-time" v-if="~item.field_name_en.indexOf('_time')">
              {{ getTableTimeItem(scope.row, item.field_name_en) }}
            </span>

            <!-- 优先级 -->
            <span class="table-item-sort-rule" v-if="item.field_name_en === 'sort_rule'">
              {{ scope.row.sort_rule.sort_name }}
            </span>

            <!-- 层级 -->
            <span class="table-item-level" v-if="item.field_name_en === 'task_level'">
              {{ getLevelText(scope.row.task_level) }}
            </span>

            <!-- 执行人 -->
            <span class="table-item-executor" v-if="item.field_name_en === 'executor_user'">
              {{ scope.row.executor_user ? scope.row.executor_user.realname : '' }}
            </span>

            <!-- 参与人 -->
            <span class="table-item-member" v-if="item.field_name_en === 'task_members_user'">
              <toolTip style="wdith:100%;" :title="getMembersText(scope.row.task_members_user)">
                <span>{{ getMembersText(scope.row.task_members_user) }}</span>
              </toolTip>
              <!-- {{ getMembersText(scope.row.task_members_user) }} -->
            </span>

            <!-- 自定义字段 -->
            <div class="customkey" v-if="item.field_type === 'custom'">
            <!-- {{ item.field_component_code }} -->
              {{ getCustomKeyItem(scope.row.template, item.field_component_code) }}
            </div>

          </div>
        </template>
      </el-table-column>

      <template slot="append">
        <div v-if="isScrollLoading" class="loading-text">数据加载中...</div>
      </template>
    </el-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    // 列表数据
    tableList: {
      type: Array,
      default: () => []
    },
    tableHeadList: {
      type: Array,
      default: () => []
    },
    // 筛选项
    filterOptions: {
      type: Object,
      default() {
        return {
          task_stage_type: 6, // 任务状态类型筛选
          task_level: 0, // 任务层级筛选
          task_list_ids: [], // 任务清单筛选
          executors_uid: [], // 执行人筛选
          task_members_uid: [], // 参与人筛选
          sort_switch: 0, // 排序开关 是否开启自定义排序
          sorting_rules: [], // 自定义排序规则
          field_display_settings: [], // 字段设置
        }
      }
    },
    // 表格高度
    height: {
      type: Number,
      default: 0
    },
    // 加载数据loading
    isScrollLoading: {
      type: Boolean,
      default: false
    },
    // 是否结束下拉加载
    finishLoad: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('customKey/customKey', {
      sort: state => state.sort,
      count: state => state.count
    })
  },
  watch: {
    // 监听筛选配置项，获取最新的数据
    filterOptions: {
      deep: true,
      handler(val) {
        const _arr = JSON.parse(JSON.stringify(this.tableHeadList))
        if (!val.sort_switch) {
          // 排序设置关着
          _arr.forEach(item => item.sort = '')
        }
        // const _arr = JSON.parse(JSON.stringify(this.tableHeadList)).filter(item => item.display === true)
        // if (this.filterOptions.sort_switch && this.filterOptions.sorting_rules.length) {
        //   // 排序开关开着的情况下
        //   _arr.forEach(item => {
        //     const _item = JSON.parse(this.filterOptions.sorting_rules).find(obj => obj.hasOwnProperty(item.field_name))
        //     if (_item) {
        //       item.sort = _item[item.field_name]
        //     }
        //   })
        // }
        // if (!this.tableShowList.length) {
        //   // 初始化
        //   this.tableShowList = _arr
        // } else {
        //   // 找到改变排序设置的对应项，赋改变后的值
        //   this.tableShowList.forEach(item => {
        //     const _item = _arr.find(item2 => item2.field_name_en === item.field_name_en)
        //     if (_item && item.sort !== _item.sort) {
        //       console.log(item, 1111)
        //       this.$set(item, 'sort', _item.sort)
        //     }
        //   })
        // }
        this.tableShowList = []
        this.$nextTick(() => {
          this.tableShowList = _arr
        })
      }
    }
  },
  data() {
    return {
      tableShowList: []
    }
  },
  mounted() {
    // 监听表格的滚动条，实现下拉加载功能
    const _ele = document.querySelector('.el-table__body-wrapper')
    _ele.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 点击行，打开该任务详
    handleRowClick(row) {
      const task_id = row.id
      const task_list_id = row.task_list_id
      this.CHANGE_TASK({ visible: true, task_id, task_list_id })
    },
    // 获取需要改变样式的表格改变的样式
    getTableStyleItem(row, field_name_en) {
      if (field_name_en === 'end_time') {
        // 截止时间
        return { 'color': this.getDeadlineColor(row) }
      } else if (field_name_en === 'sort_rule') {
        // 优先级
        return { 'color': this.getRuleSortColor(row.sort_rule.sort_name) }
      }

      return {}
    },
    // 获取表格的时间的内容
    getTableTimeItem(row, field_name_en) {
      if (field_name_en === 'end_time') {
        // 截止时间
        return this.getDeadline(row)
      } else {
        // 其他时间
        return row[field_name_en] ? row[field_name_en].replace(/-/g,'/') : ''
      }
    },
    // 获取自定义字段的表格数据
    getCustomKeyItem(template, component_code) {
      let _val = ''
      if (template) {
        template.template_standard_components.forEach(item => {
          if (item.component_code === component_code) {
            if (item.component_values.length) {
              switch(component_code) {
                case 'TaskComponent.Option.Checkbox':
                  // 多选
                  _val = (item.component_values.map(data => data.component_value)).join(', ')
                  break
                case 'TaskComponent.Object.Participant':
                  // 成员
                  _val = (item.component_values.map(data => data.user.realname)).join(', ')
                  break
                default:
                  _val = item.component_values[0].component_value
              }
            }
          }
        })
      }
      return _val
    },
    // 获取截止时间颜色
    getDeadlineColor(data) {
      let _color = ''
      if (!data.end_time || data.task_stage === '已归档' || data.task_stage === '已完成') return
      let nowTime = new Date().getTime()
      let expired = 24 * 60 * 60 * 1000
      if (new Date(data.end_time).getTime() + expired < nowTime) {
        _color = 'rgba(255, 57, 57, .9)'
      } else if (new Date(data.end_time).getTime() < nowTime) {
        _color = 'rgba(255, 139, 35, .9)'
      }
      return _color
    },
    // 获取截止时间
    getDeadline(data) {
      let _time = ''
      if (!data.start_time || !data.end_time) return
      _time = `${ data.start_time }~${ data.end_time }`.replace(/-/g,'/')
      return _time
    },
    // 获取优先级颜色
    getRuleSortColor(ruleSort) {
      let _color = ''
      switch (ruleSort) {
        case '最高':
          _color = '#FF3939'
          break
        case '中等':
          _color = '#FF7911'
          break
        case '普通':
          _color = '#2682FF'
          break
        case '低':
          _color = 'rgba(32, 32, 32, .8)'
          break
      }
      return _color
    },
    // 获取层级
    getLevelText(level) {
      let _msg = ''
      switch (true) {
        case level <= 1:
          _msg = '父任务'
          break
        case level === 2:
          _msg = '子任务'
          break
        default:
          _msg = '孙任务'
          break
      }
      return _msg
    },
    // 获取参与人
    getMembersText(list) {
      let _text = ''
      if (!list.length) return
      _text = list.reduce((pre, cur) => {
        return pre += `${ cur.user.realname }、`
      }, '')
      return _text.slice(0, -1)
    },
    handleScroll() {
      const _ele = document.querySelector('.el-table__body-wrapper') //获取滚动可视区域的元素
      const _ele2 = _ele.querySelector('.el-table__body') // 获取滚动区域的元素
      const scrollTop = _ele.scrollTop // 获取滚动条距离顶部的距离
      const clientHeight = _ele.clientHeight // 获取可视区域的高度
      const scrollHeight = _ele2.scrollHeight // 获取滚动区域的总高度

      // console.log(scrollTop, clientHeight, scrollHeight, 111)
      if (scrollTop + clientHeight >= scrollHeight && !this.isScrollLoading) {
        // 已滚动到底部并且不处于加载状态
        this.load()
      }
    },
    load() {
      this.$emit('load')
    },
    // 表格筛选
    handleTableSort(val, item) {
      this.$nextTick(() => {
        item.sort = val
      })

      this.$emit('tableSortChange', item.field_name, val)
    },
    doLayout() {
      this.$refs.table.doLayout()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.statistics-table-container {
  .table-sort-header {
    display: flex;
    align-items: center;
    .tit {
      margin-right: 8px;
      line-height: 24px;
    }
    .sort-name {
      cursor: pointer;
      @include fontColorOpacity(.6);
      &:hover {
        color: #2682FF;
        i {
          color: #2682FF;
        }
      }

      &:active {
        color: #0463D6;
        i {
          color: #0463D6;
        }
      }
    }
    .icon {
      font-size: 14px;
      &.isChos {
        color: #0D70E8;
      }
    }
  }
}

.statistics-table-sort-dropdown {
  padding: 8px 0;
  li {
    width: 170px;
    height: 40px;
    padding: 0 16px 0 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include fontColorOpacity(1);
    i {
      color: #0D70E8;
    }
  }
}


.loading-text {
  text-align: center;
  font-size: 14px;
  line-height: 32px;
  @include fontColorOpacity(.6);
}
/deep/ .el-table--border th:first-child .cell,
/deep/ .el-table--border td:first-child .cell {
  padding-left: 40px;
}
/deep/ .el-table__empty-text {
  display: none;
}
</style>
